import Control from './control';
import { RecorderAPI } from '../../recorderApi';
import defaultsDeep from 'lodash-es/defaultsDeep';
import each from 'lodash-es/each';
import { updateClasses, getDefaultControl, buttonStyle } from './recorder.defaults';
import uniqueId from '../uniqueId';
import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import frameProps from '../css/frameProps';
import {renderControls} from '../renderControls';



var icons = {
  record:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF0000' d='M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z' /%3E%3C/svg%3E",
  replay: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z' /%3E%3C/svg%3E",
  pause: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M14,19H18V5H14M6,19H10V5H6V19Z' /%3E%3C/svg%3E",
  recording: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF0000' d='M18,14.5V11A1,1 0 0,0 17,10H16C18.24,8.39 18.76,5.27 17.15,3C15.54,0.78 12.42,0.26 10.17,1.87C9.5,2.35 8.96,3 8.6,3.73C6.25,2.28 3.17,3 1.72,5.37C0.28,7.72 1,10.8 3.36,12.25C3.57,12.37 3.78,12.5 4,12.58V21A1,1 0 0,0 5,22H17A1,1 0 0,0 18,21V17.5L22,21.5V10.5L18,14.5M13,4A2,2 0 0,1 15,6A2,2 0 0,1 13,8A2,2 0 0,1 11,6A2,2 0 0,1 13,4M6,6A2,2 0 0,1 8,8A2,2 0 0,1 6,10A2,2 0 0,1 4,8A2,2 0 0,1 6,6Z' /%3E%3C/svg%3E",
  pauseResume: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M15,16H13V8H15M11,16H9V8H11M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z' /%3E%3C/svg%3E",
  download: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z' /%3E%3C/svg%3E",
  upload: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M20.54,5.23C20.83,5.57 21,6 21,6.5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M5.12,5H18.87L17.93,4H5.93L5.12,5M12,9.5L6.5,15H10V17H14V15H17.5L12,9.5Z' /%3E%3C/svg%3E",
};



const defaultFrame = {
  position: 'absolute',
  display: 'block',
  overflow: 'hidden',
  top: '8px',
  left: '8px',
  width: '120px',
  height: '32px',
  userSelect: 'none',
}

export default class Recorder extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);    
    this._icons = {...icons};
  }

  onReady(){
    super.onReady();
    if(this.isLayoutMode) {return;}

    this.on('recorderStart', (event, control, component) => {  
      component.getControl(control.id+'_record').showEffect();
      component.getControl(control.id+'_pause').setDisabled(false);
      component.getControl(control.id+'_pause').setIsChecked(false);
      component.getControl(control.id+'_replay').setDisabled(true);
      component.getControl(control.id+'_download').setDisabled(true);
      component.getControl(control.id+'_upload').setDisabled(true);
    });

    this.on('recorderLevel', (event, control, component, anchor, data) => {
      // console.log('recorderLevel');
      component.getControl(control.id+'_record').setEffectLevel(data[0]*1.2+0.2);
    });

    this.on('recorderStop,recorderError', (event, control, component, anchor, data) => {
      component.getControl(control.id+'_record').hideEffect();
      component.getControl(control.id+'_record').setIsChecked(false);
      component.getControl(control.id+'_pause').setDisabled(true);
      component.getControl(control.id+'_pause').setIsChecked(false);
      component.getControl(control.id+'_replay').setDisabled(false);
      component.getControl(control.id+'_download').setDisabled(false);
      component.getControl(control.id+'_upload').setDisabled(false);
      control.setValue(control.recorder.getFileNames()+'');
      if(event!='recorderError'){
        control.doResetReload();        
      }else{
        console.log(data[1].message,data[1].error);
        control.render();
      }
    });
  }

  getDefaults(){
    if(!this._defaults){
      this._defaults = {
        style: {
          normal: {
            height: '48px',
            width: 'auto',
            display: 'inline-block',
            backgroundColor:'transparent'
          },
        },
        video:{
          enabled:true
        },
        buttons:{
          record:{
            type: 'button',
            isToggle:true,               
            style: buttonStyle,
            icon: {
              url: this._icons.record,
              size:'80%'
            },
            iconActive: {
              url: this._icons.recording
            },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],
            effect:{
              repeat:'controlled',
              speed:'fast',
              visible:true,
              style:{
                backgroundColor:'#FF0000',              
                boxShadow:'none',
                borderColor:'#FF0000',
                borderWidth:'0px'
              }
            },
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                const state = control.parentControl.recorder.getState();
                if(state=='inactive'){
                  console.log('recording..')
                  control.parentControl.recorder.start();
                }else if(state=='recording'||state=='paused'){
                  console.log('stop recording..')
                  control.parentControl.recorder.stop();
                }
              }
            }
          },
          pause:{
            type: 'button',
            visible:false,
            // visible:true,
            disabled: true,
            isToggle:true,             
            style: buttonStyle,
            icon: {
              url: this._icons.pause
            },
            iconActive: {
              url: this._icons.pauseResume,
              size:'80%'
            },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                const state = control.parentControl.recorder.getState();
                if(state=='recording'){
                  console.log('pause recording..')
                  control.parentControl.recorder.pause();
                }else if(state=='paused'){
                  console.log('resume recording..')
                  control.parentControl.recorder.resume();
                }              
              }
            }
          },
          replay:{
            type: 'button',
            visible:false,
            // visible:true,
            disabled: true,
            // isToggle:true,            
            style: buttonStyle,
            icon: {
              url: this._icons.replay,
              size:'80%'
            },
            // iconActive: {
            //   url: this._icons.stop
            // },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],      
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                console.log('replay recording..')
                control.parentControl.recorder.replay();
              }
            }
          },
          download:{
            type: 'button',
            visible:false,
            // visible:true,
            disabled: true,
            // isToggle:true,            
            style: buttonStyle,
            icon: {
              url: this._icons.download,
              size:'80%'
            },
            // iconActive: {
            //   url: this._icons.stop
            // },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                console.log('download recording..')
                control.parentControl.recorder.download();
              }
            }
          },
          upload:{
            type: 'button',
            visible:false,
            // visible:true,
            disabled: true,
            // isToggle:true,            
            style: buttonStyle,
            icon: {
              url: this._icons.upload,
              size:'80%'
            },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],
            // iconActive: {
            //   url: this._icons.stop
            // },          
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                console.log('upload recording..')
                control.parentControl.recorder.upload();
              }
            }
          },
        },            
      };
    }

    return this._defaults;
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;
    
    // console.log('renderElement', control, options, instance, path);
    defaultsDeep(options, this.getDefaults());

    if (!control.el) {
      control.el = getDefaultControl();
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-recorder-',Recorder);
        control.styleSheet = 'css-' + control.id;
        control.recorder = new RecorderAPI(control,'options');
      }else{
        control.el.setAttribute('id',control.id);
      }
    }

    options.buttons.record.name = control.id+'_record';
    options.buttons.pause.name = control.id+'_pause';
    options.buttons.replay.name = control.id+'_replay';
    options.buttons.download.name = control.id+'_download';
    options.buttons.upload.name = control.id+'_upload';
    // if(control.isLayoutMode){
    //   options.buttons.record.style.normal.pointerEvents = 'none!important';
    //   options.buttons.pause.style.normal.pointerEvents = 'none!important';
    //   options.buttons.replay.style.normal.pointerEvents = 'none!important';
    //   options.buttons.download.style.normal.pointerEvents = 'none!important';
    //   options.buttons.upload.style.normal.pointerEvents = 'none!important';
    // }
    
    options.controls = [
      options.buttons.record,
      options.buttons.pause,
      options.buttons.replay,
      options.buttons.download,
      options.buttons.upload
    ];
    

    updateClasses(control,options);
    
    // var bodyEl = control.el.getElementsByClassName('body')[0];
    

    var frameStylePatch = _.pick(merge({},getDefaultStyle(),defaultFrame, options.style.normal), frameProps);

    let scheme = lookAndFeel(options.lookAndFeel, options.style.normal.height);

    updateStyleByRef(frameStylePatch, scheme);
    updateStyle(control.el, frameStylePatch, control.currentFrameStyle);

    control.currentFrameStyle = frameStylePatch;
    
      each(options.controls, function(ctrl) {
        ctrl.lookAndFeel = merge({}, options.lookAndFeel, ctrl.lookAndFeel);
        if (!ctrl.style) {
          ctrl.style = {};
        }

        ctrl.style.normal = merge({}, ctrl.style.normal, {
          pointerEvents: 'auto',
        });
      });
      renderControls(instance, path,control.nicePath, control.el);

    return control.el;
  
  }

  toggle(event,me=this,cmp=me.instance,anchor,[ev]=[]){
    // console.log('recorder:',event);
    const hit = ev===undefined
    || ev.target === me.el
    || ev.target === me.el.firstChild
    || ( me.options.attachTo!=='icon'
    && ( ev.target === me.parentControl.el
        ||ev.target === me.parentControl.el.firstChild)
    );
      
    if(hit){
      if(me.options.group){
        const current = me.instance.recorderGroups[me.options.group];
        if(current && current!==me.path){
          me.instance.controls[current].toggle(event=='click'&&event||'mouseleave');
        }
      }
    }

    if(event == 'clickOutside' || hit){

      if(event=='click'){
        me.showRecorder = !me.showRecorder;        
      }else if(event=='mouseenter'){
        me.showRecorder = true;
        if(me.options.hideAfter){
          me._hideTimer = setTimeout(()=>{
            if(me.showRecorder){
              me.showRecorder=false;
              me.render();
              delete me._hideTimer;
            }
          },me.options.hideAfter*1000);
        }
      }else{
        if(event=='clickOutside'&&me.options.hideOnClickOutside
          ||event=='mouseleave'&&me.options.hideOnMoveOutside){

          me.showRecorder = false;
          if(me._hideTimer){
             clearTimeout(me._hideTimer);
             delete me._hideTimer;
          }

        }
      }

      if(me.options.group){
        if(me.showRecorder){
          me.instance.recorderGroups[me.options.group] = me.path;
        }else if(me.instance.recorderGroups[me.options.group] == me.path){
          me.instance.recorderGroups[me.options.group] = null;
        }
      }

      if(ev && event !== 'clickOutside') {ev.stopPropagation();}

      if(ev && event!=='mouseleave'){
        me.ev = ev;        
      }

      if(!me.showRecorder){
        setTimeout(()=>{
          me.render();        
          me.raiseEvent('isExpanded',{value:me.showRecorder,oldValue:!me.showRecorder},ev);
        },100)
      }else{
        me.render();        
        me.raiseEvent('isExpanded',{value:me.showRecorder,oldValue:!me.showRecorder},ev);
      }
    }
  }

  dropBoxUpload(path, file, onProgress){
    return this.instance.dropBoxUpload(path, file, onProgress);
  }

  dropBoxMput(path, file, codec, partId, close, onProgress){
    return this.instance.dropBoxMput(path, file, codec, partId, close, onProgress);
  }

  
}
